import _ from 'lodash';
import React, {useState} from 'react';
import styles from './InfoButton.module.scss';
import posed from 'react-pose';
import {InfoButtonIcon} from '../game/commonAnimations';
import * as audioBundle from '../audioBundle';

const screenDuration = 600;
const contentDelay = 400;

const InfoScreen = posed.div({
    visible: {
        y: 0,
        transition: {duration: 0},
    },
    hidden: {
        y: '-100%',
        delay: screenDuration + contentDelay,
        transition: {duration: 0},
    },
});

const Background = posed.div({
    visible: {
        y: 0,
        transition: {
            ease: 'easeOut',
            duration: screenDuration,
        },
    },
    hidden: {
        y: '-100%',
        delay: contentDelay,
        transition: {
            ease: 'easeIn',
            duration: screenDuration,
        },
    },
});

const CloseButton = posed.div({
    visible: {
        rotate: 0,
        transition: {
            ease: 'easeOut',
            duration: screenDuration,
        },
    },
    hidden: {
        rotate: 180,
        delay: contentDelay,
        transition: {
            ease: 'easeIn',
            duration: screenDuration,
        },
    },
});

const Column = posed.div({
    visible: {
        x: 0,
        delay: contentDelay,
        transition: {
            ease: 'easeOut',
            duration: screenDuration,
        },
    },
    hidden: {
        x: props => (props.direction > 0 ? '50vw' : '-50vw'),
        transition: {
            ease: 'easeIn',
            duration: screenDuration,
        },
    },
});

const RestartBox = posed.div({
    visible: {
        y: 0,
        delay: contentDelay,
        transition: {
            ease: 'easeOut',
            duration: screenDuration,
        },
    },
    hidden: {
        y: '20vh',
        transition: {
            ease: 'easeIn',
            duration: screenDuration,
        },
    },
});

export default function InfoButton({game, onResetGame}) {
    const [screenVisible, setScreenVisible] = useState(false);

    const updateScreenVisible = value => {
        audioBundle.play('infoPanel');
        setScreenVisible(value);
    };

    const pose = screenVisible ? 'visible' : 'hidden';

    return (
        <div>
            <InfoButtonIcon
                className={styles.infoButton}
                onClick={() => updateScreenVisible(true)}
            />

            <InfoScreen className={styles.infoScreen} pose={pose}>
                <Background className={styles.background} />

                <div className={styles.paper}>
                    <CloseButton
                        className={styles.closeButton}
                        onClick={() => updateScreenVisible(false)}
                    />

                    <div className={styles.description}>
                        <Column className={styles.column} direction={-1}>
                            <div className={styles.headerBlock}>
                                <div className={styles.header}>Game Directions</div>
                                <div className={styles.headerLine} />
                            </div>
                            <div className={styles.paragraph}>
                                • Participants break into two teams to compete to identify
                                the name of an artist.
                            </div>
                            <div className={styles.paragraph}>
                                • Team 1 starts the first round by listening to a
                                one-second excerpt of a song.
                            </div>
                            <div className={styles.paragraph}>
                                • If Team 1 correctly names the artist, they are awarded
                                10 points.
                            </div>
                            <div className={styles.paragraph}>
                                • Once a team correctly guesses the artist, both teams
                                analyze lyrics in the discussion round.
                            </div>
                        </Column>

                        <Column className={styles.column} direction={1}>
                            <div className={styles.headerBlock}>
                                <div className={styles.header}>Discussion Section</div>
                                <div className={styles.headerLine} />
                            </div>
                            <div className={styles.paragraph}>
                                • Both teams are asked to read an excerpt of a lyric of a
                                song they just heard, and then analyze the content.
                            </div>
                            <div className={styles.paragraph}>
                                • Think about and respond to the following questions:
                            </div>
                            <div className={styles.paragraph}>
                                1) What message is the artist sending about conflict
                                resolution?
                            </div>
                            <div className={styles.paragraph}>
                                2) What kind of influence do you think this message is
                                having among teens?
                            </div>
                        </Column>
                    </div>

                    <RestartBox className={styles.restartBox} onClick={onResetGame}>
                        <div className={styles.restartIcon} />
                        <div className={styles.restartText}>Restart</div>
                    </RestartBox>
                </div>
            </InfoScreen>
        </div>
    );
}
